import messages from '../locales/messages';
import 'src/common/style/common.scss';
import { ReactElement, useEffect, useState } from 'react';
import { ThanksModal, ThanksTableVerbiage } from 'src/common/utils/ThanksModal';
import { createUseTranslation } from '../../../common/hooks/widgets/useTranslation';
import { useQradarEDRSelector } from '../lib/redux/hooks';

export interface thanksProps {
  totalYrlyPrice: string;
  totalMthlyPrice: string;
  bpName: string;
  bpConsentMail: boolean;
  offerings: string;
  endpoints: number;
}

const Thanks = ({
  totalYrlyPrice,
  totalMthlyPrice,
  bpName,
  bpConsentMail,
  offerings,
  endpoints,
}: thanksProps): ReactElement => {
  const AEMMessages = useQradarEDRSelector(
    (state) => state.translations.messages,
  );
  const useTranslation = createUseTranslation(messages, AEMMessages);

  const [showThanksModal, setShowThanksModal] = useState(true);

  const titleThanks: ThanksTableVerbiage[] = [
    {
      group: 'title',
      value: useTranslation('thank_you'),
    },
    {
      group: 'subTitle',
      value: useTranslation('ty_insights'),
    },
    {
      group: 'subTitle',
      value: useTranslation('received_text'),
    },
  ];
  const widgetTitleThanks: ThanksTableVerbiage[] = [
    {
      group: 'widgetTitle1',
      value: useTranslation('req_detail'),
    },
  ];
  const contentThanks: ThanksTableVerbiage[] = [
    {
      group: useTranslation('offerings'),
      value: String(offerings),
    },
    {
      group: useTranslation('triggertextWorkstations'),
      value: String(endpoints),
    },
    {
      group: useTranslation('estimatedYearlyCosts'),
      value: String(totalYrlyPrice),
    },
    {
      group: useTranslation('estimatedMondthlyCosts'),
      value: String(totalMthlyPrice),
    },
  ];
  bpName &&
    contentThanks.push({
      group: useTranslation('bp_title'),
      value: bpName,
    });
  bpName &&
    contentThanks.push({
      group: 'I consent to IBM providing my business contact information: ',
      value: bpConsentMail ? 'Yes' : 'No',
    });
  const buttonThanks: ThanksTableVerbiage[] = [
    {
      group: 'button1',
      value: useTranslation('returnToEstimator'),
    },
  ];
  const [showModal, setShowModal] = useState(false);
  useEffect(() => {
    setShowModal(true);
  }, [endpoints]);
  return (
    <ThanksModal
      showThanksModal={showModal}
      pageTitle="QRadar EDR Pricing Page"
      object="Pricing Page"
      productTitle={'QRadar EDR estimator'}
      pageUrl={''}
      location={'Estimator'}
      titleThanks={titleThanks}
      widgetTitleThanks={widgetTitleThanks}
      contentThanks={contentThanks}
      buttonThanks={buttonThanks}
      setShowThanksModal={setShowThanksModal}
    ></ThanksModal>
  );
};

export default Thanks;
